import type { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from '@remix-run/react';

interface SearchResultGroupProps {
  title: string;
  count: number;
  viewAllHref: string;
  onViewAllClick?: () => void;
  children: ReactNode;
}

export const SearchResultGroup: FC<SearchResultGroupProps> = ({
  title,
  count,
  viewAllHref,
  onViewAllClick,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-2 px-3 py-1.5">
        <span className="text-xs font-semibold text-black/50 uppercase tracking-wide">{title}</span>
        <span className="text-xs text-black/40 font-medium">{count}</span>
      </div>
      {children}
      {count > 3 && (
        <Link
          to={viewAllHref}
          onClick={onViewAllClick}
          className="flex items-center px-3 py-1.5 text-sm font-medium text-black/60 hover:text-black transition-colors"
        >
          {t('community.search.view_all')}
        </Link>
      )}
    </div>
  );
};
